"use client";

import { useEffect, useRef, type ReactNode } from "react";

const DESKTOP_QUERY = "(min-width: 64rem)";

export function CompanionResponsiveDetails({
  className,
  children,
}: {
  className: string;
  children: ReactNode;
}) {
  const detailsRef = useRef<HTMLDetailsElement>(null);

  useEffect(() => {
    const media = window.matchMedia(DESKTOP_QUERY);
    const sync = () => {
      if (detailsRef.current) detailsRef.current.open = media.matches;
    };
    sync();
    media.addEventListener("change", sync);
    return () => media.removeEventListener("change", sync);
  }, []);

  return (
    <details ref={detailsRef} className={className}>
      {children}
    </details>
  );
}
